import React, { Component, createRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Button from "../../components/Button";
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter,
} from "../../components/Modal";
import {
  closeModal,
  cloneEmailTemplate,
  emailTemplatesList,
  gotoUrl,
} from "../../actions";
import styles from "../../components/Modal.module.css";

export class CloneEmailModal extends Component {
  constructor(props) {
    super(props);
    this.clone = this.clone.bind(this);
    this.nameRef = createRef();
  }

  componentDidMount() {
    if (this.nameRef?.current) {
      this.nameRef.current.focus();
    }
  }

  clone(e) {
    if (e) {
      e.preventDefault();
    }

    const { accountId, emailTemplate } = this.props;

    this.props
      .cloneEmailTemplate(accountId, emailTemplate.id, {
        name: this.nameRef?.current.value,
      })
      .then((data) => {
        const nextId = data.data.id;
        return this.props.gotoUrl(
          "/clients/" + accountId + "/email-templates/" + nextId
        );
      })
      .then(this.props.closeModal);
  }

  render() {
    const { emailTemplate } = this.props;

    return (
      <Modal>
        <ModalHeader>Clone Email Template</ModalHeader>
        <ModalContent>
          <form className={styles.flex} onSubmit={this.clone}>
            <label>Name</label>
            <input
              ref={this.nameRef}
              autofocus="true"
              defaultValue={`${emailTemplate.name} copy`}
            />
          </form>
        </ModalContent>
        <ModalFooter>
          <Button type="link" onClick={this.props.closeModal}>
            Cancel
          </Button>
          <Button onClick={this.clone}>Clone</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

CloneEmailModal.propTypes = {
  cloneEmailTemplate: PropTypes.func.isRequired,
  emailTemplatesList: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  emailTemplates: PropTypes.array.isRequired,
  gotoUrl: PropTypes.func.isRequired,
  accountId: PropTypes.string.isRequired,
};

// Connect state data
function mapStateToProps(state) {
  const { params } = state.modal;
  const { accountId, id } = params;
  const emailTemplate = state.entities.emailTemplate[id];

  return {
    accountId,
    id,
    emailTemplate,
  };
}

// Connect actions
export default connect(mapStateToProps, {
  closeModal,
  cloneEmailTemplate,
  emailTemplatesList,
  gotoUrl,
})(CloneEmailModal);
